import { render } from "./Data-management-service-en.vue?vue&type=template&id=354b4982&scoped=true"
import script from "./Data-management-service-en.vue?vue&type=script&lang=js"
export * from "./Data-management-service-en.vue?vue&type=script&lang=js"

import "./Data-management-service-en.vue?vue&type=style&index=0&id=354b4982&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354b4982"]])

export default __exports__